import { useState, useEffect } from 'react';

export const useGuide = (pageName) => {
  const [isGuideVisible, setIsGuideVisible] = useState(false);
  const [hasSeenGuide, setHasSeenGuide] = useState(false);

  useEffect(() => {
    // Check if user has seen this guide before
    const seenGuides = JSON.parse(localStorage.getItem('seenGuides') || '{}');
    setHasSeenGuide(seenGuides[pageName] || false);
  }, [pageName]);

  const showGuide = () => {
    setIsGuideVisible(true);
  };

  const hideGuide = () => {
    setIsGuideVisible(false);
    // Mark this guide as seen
    const seenGuides = JSON.parse(localStorage.getItem('seenGuides') || '{}');
    seenGuides[pageName] = true;
    localStorage.setItem('seenGuides', JSON.stringify(seenGuides));
    setHasSeenGuide(true);
  };

  const resetGuideStatus = () => {
    const seenGuides = JSON.parse(localStorage.getItem('seenGuides') || '{}');
    delete seenGuides[pageName];
    localStorage.setItem('seenGuides', JSON.stringify(seenGuides));
    setHasSeenGuide(false);
  };

  return {
    isGuideVisible,
    hasSeenGuide,
    showGuide,
    hideGuide,
    resetGuideStatus
  };
};